var divider_viewer_rtlignore_default = {
  "divider-container": "_0jj6Y",
  "divider-container--double": "QdOZ3",
  "divider": "_2lsaE",
  "divider--single": "sYCoG",
  "divider--double": "QGCO2",
  "divider--dashed": "Prn08",
  "divider--dotted": "LKdCn",
  "divider--small": "r3uHb",
  "divider--medium": "IIK9N",
  "divider--large": "wv3A6",
  "divider--left": "RtIBk",
  "divider--center": "we2bw",
  "divider--right": "A3qra",
  "svgFixerContainer": "IhffT",
  "emptyChar": "LIWUB"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
